;(function () {
  'use strict'

  angular
    .module('contrast.errors')
    .controller('ErrorCtrl', ['$scope', 'home', ErrorCtrl])

  function ErrorCtrl($scope, home) {
    $scope.home = home
  }
})()
